<template>
    <div class="upload">
        <IconComponent class="close" icon="close" @click="$emit('cancel')"></IconComponent>
        <h2 class="title" v-text="previewFile.name"></h2>
        <div class="preview">
            <img :src="previewImage" v-if="previewImage">
            <IconComponent class="preview_document" icon="file" v-else>
            </IconComponent>
        </div>
        <div class="caption">
            <input type="text" v-model="message" @keydown.enter="upload">
        </div>
        <div class="actions">
            <div class="actions_files">
                <div class="actions_file" v-for="file, i in files" :key="i" @click="index = i"
                    :class="{ active: index == i }">
                    <IconComponent class="actions_icon" icon="file">
                    </IconComponent>
                </div>
            </div>
            <IconComponent class="actions_send" icon="send" @click="upload">
            </IconComponent>
        </div>
    </div>
</template>

<script>
import IconComponent from "@/components/Icons.vue"

export default {
    name: 'UploadFiles',
    props: {
        files: { required: true },
        projectId: { required: true },
    },
    components: {
        IconComponent,
    },
    data() {
        return {
            index: 0,
            message: "",
            previewImage: null,
        }
    },
    methods: {
        upload() {
            if (this.filesUploaded >= this.files.length) {
                console.log('all files have been uploaded')
                return
            }
            this.$store.dispatch('projects/sendFile', {
                projectId: this.projectId,
                file: this.files[this.filesUploaded]
            })
        },
    },
    computed: {
        isImage() {
            if (this.previewFile == null) {
                return false
            }
            const hasImageType = this.previewFile.type.startsWith('image')
            const compatibleFormats = [
                'png', 'jpeg', 'gif',
            ]
            let hasCompatibleFormat = false
            for (const format of compatibleFormats) {
                if (this.previewFile.type.endsWith(format)) {
                    hasCompatibleFormat = true
                    break
                }
            }
            return hasImageType && hasCompatibleFormat
        },
        previewFile() {
            console.log(this.files[0])
            return this.files[this.index]
        },
        uploaded() {
            return this.$store.state.projects.uploaded
        },
        filesUploaded() {
            return this.uploaded.length
        },
    },
    watch: {
        previewFile: {
            immediate: true,
            handler() {
                if (!this.isImage) {
                    this.previewImage = null
                    return
                }
                const fileReader = new FileReader()
                fileReader.onload = event => {
                    this.previewImage = event.target.result
                }
                fileReader.readAsDataURL(this.previewFile)
            },
        },
        filesUploaded() {
            if (this.filesUplodaded == 0) {
                return
            }
            if (this.filesUploaded < this.files.length) {
                this.upload()
                return
            }
            if (this.message != "") {
                this.$store.dispatch('projects/sendMessage', {
                    projectId: this.projectId,
                    message: this.message,
                })
            }
            this.$store.commit('projects/clearUploaded')
            this.$emit('done')
        },
    },
}
</script>

<style lang="scss" scoped>
.upload {
    display: grid;
    height: 100%;
    overflow: hidden;
    grid-template-rows: min-content 1fr min-content min-content;
    grid-template-columns: min-content 1fr;
    grid-template-areas:
        "close title"
        "preview preview"
        "caption caption"
        "actions actions"
    ;

    &,
    &::before {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 10;
    }

    &::before {
        content: '';
        background: var(--bg-color);
        opacity: .95;
        z-index: -1;
    }

    .close {
        grid-area: close;
        height: 20px;
        width: 20px;
        cursor: pointer;
        margin: 20px;
    }

    .title {
        grid-area: title;
        margin: auto;
        font-size: 1.1rem;
    }

    .preview {
        grid-area: preview;
        height: 100%;
        min-height: 0;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
            min-width: 0;
            min-height: 0;
            max-width: 90%;
            max-height: 90%;
        }
    }

    .caption {
        grid-area: caption;
        padding: 1rem;
        margin: auto;
        max-width: 700px;
        width: 100%;

        input {
            width: 100%;
            padding: 1rem;
            background: var(--bg-color-3);
            border: none;
            outline: none;
            color: var(--text-color);
            font-size: 1rem;
            border-radius: .5rem;
        }
    }

    .actions {
        grid-area: actions;
        padding: 1rem;
        border-top: 1px solid var(--bg-color-2);
        display: flex;

        &_files {
            display: flex;
            margin: auto;
            width: fit-content;
            gap: 1rem;
        }

        &_file {
            height: 50px;
            width: 50px;
            background-color: var(--bg-color-2);
            cursor: pointer;
            padding: 8px;
            border: 2px solid var(--bg-color-2);
            border-radius: 4px;

            &.active {
                border-color: var(--highlight-color);
            }
        }

        &_icon {
            height: 100%;
            width: 100%;
        }

        &_send {
            height: 30px;
            width: 30px;
            margin: auto 0;
            cursor: pointer;
        }
    }
}
</style>
